<template>
    <div>
        <div class="row">
            <div class="col-12 col-sm-6" v-if="$loadModule('billing')">
                <report-card :value="reports.totalIncome" label="Total earned" icon="fe fe-dollar-sign" money></report-card>
            </div>
            <div class="col-12 col-sm-6"  v-if="$loadModule('billing')">
                <report-card :value="reports.totalPaid" label="Total paid" icon="fe fe-dollar-sign" money></report-card>
            </div>
            <div class="col-12 col-sm-6"  v-if="$loadModule('billing')">
                <report-card :value="reports.totalRevenue" :label="revenueLabel" icon="fe fe-dollar-sign" money></report-card>
            </div>
            <div class="col-12 col-sm-6" v-if="$hasPermission('reports-summary', ['seeAll']) && $loadModule('billing')">
                <report-card :value="reports.totalExpenditure" label="Total expenditure" icon="fe fe-dollar-sign" money></report-card>
            </div>
            <div class="col-12 col-sm-6" v-if="$hasPermission('reports-summary', ['seeAll']) && $loadModule('billing')">
                <report-card :value="reports.totalLeftover" label="Left over" icon="fe fe-dollar-sign" money></report-card>
            </div>
            <div class="col-12 col-sm-6" v-if="$hasPermission('balance-reports', ['seeAll']) && $loadModule('billing')">
                <report-card
                    :value="reports.totalDebt"
                    label="Total debt for end of period"
                    icon="fe fe-dollar-sign"
                    money
                ></report-card>
            </div>
            <div class="col-12 col-sm-6" v-if="$hasPermission('balance-reports', ['seeAll']) && $loadModule('billing')">
                <report-card
                    :value="reports.currentDebt"
                    label="Debt for period of time"
                    icon="fe fe-dollar-sign"
                    money
                ></report-card>
            </div>
            <div class="col-12 col-sm-6">
                <report-card :value="reports.totalAppointments" label="Appointments scheduled" icon="fe fe-calendar"></report-card>
            </div>
            <div class="col-12 col-sm-6">
                <report-card :value="reports.totalScheduled" label="Appointments created" icon="fe fe-calendar"></report-card>
            </div>
            <div class="col-12 col-sm-6">
                <report-card :value="reports.email" label="Email" icon="fe fe-mail"></report-card>
            </div>
            <div class="col-12 col-sm-6">
                <report-card :value="reports.sms" label="SMS" icon="fe fe-message-circle"></report-card>
            </div>
            <div class="col-12 col-sm-6">
                <report-card :value="reports.media" label="Media" icon="fe fe-file" bytes></report-card>
            </div>
        </div>
    </div>
</template>

<script>
import ReportCard from "./ReportCard.vue";
import { mapActions } from "vuex";
import { debounce } from 'lodash';

export default {
    components: {
        ReportCard
    },
    props: { user: Array, dates: Object, branchesId: Array },
    data() {
        return {
            reports: {}
        };
    },

    computed: {
        revenueLabel() {
            return this.$hasPermission('sales-reports', ['seeAll']) ? 'Total revenue' : 'Your revenue'
        },
        summaryQueryParams() {
            let query = {};
            if (this.dates.start) {
                query.date = {
                    $gte: this.dates.start,
                    $lte: this.dates.end
                }
            }

            if (this.branchesId.length > 0)
                query.branchesId = this.branchesId;

            if (this.user.length > 0)
                query.user = { $in: this.user };
            return query;
        },
        mediaQueryParams() {
            let query = {};
            if (this.dates.start) {
                query.createdAt = {
                    $gte: this.dates.start,
                    $lte: this.dates.end
                }
            }

            if (this.user.length > 0)
                query.userId = { $in: this.user };
            return query;
        },
        notificationLogsQueryParams() {
            let query = {};
            if (this.dates.start) {
                query.createdAt = {
                    $gte: this.dates.start,
                    $lte: this.dates.end
                }
            }

            if (this.branchesId.length > 0)
                query.branchesId = this.branchesId;

            return query;
        }
    },

    watch: {
        summaryQueryParams() {
            this.fetchSalesReport();
        }
    },

    mounted () {
        this.fetchSalesReport();
        this.$root.$on("bv::hide::modal", () => {
            this.fetchSalesReport();
        })
    },

    methods: {
        ...mapActions("reports-summary", { fetchSummaryReports: "find" }),
        ...mapActions("notification-reports", { fetchNotificationReports: "find" }),
        ...mapActions("media-summary", { findMediaLogs: "find" }),

        fetchSalesReport: debounce(function (){
            this.reports = {};
            this.fetchSummaryReports({ query: this.summaryQueryParams }).then(data => {
                data = data[0];
                Object.keys(data).forEach(key => {
                    this.$set(this.reports, key, data[key]);
                });
            });

            this.findMediaLogs({ query: this.mediaQueryParams }).then(data => {
                this.$set(this.reports, "media", data[0].total);
            });

            this.fetchNotificationReports({ query: this.notificationLogsQueryParams }).then(data => {
                this.$set(this.reports, "sms", data[0].sms);
                this.$set(this.reports, "email", data[0].email);
            });
        }, 200)
    }
};
</script>


